export enum PERSONAL_INFO_TYPE {
  CN = 'CN',
  EU = 'EU',
  OTHERS = 'OTHERS',
}

export type ApplicationDeclarationData = {
  informationAccuracy: boolean;
  confirmation: boolean;
  personalType?: PERSONAL_INFO_TYPE; // CN, EU and Others
  engagement?: boolean;
};
